import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { ROUTES } from "@/config/constants";

export function RouteErrorFallback() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? error.statusText || error.data?.toString?.() || "Erro na rota."
    : error instanceof Error
      ? error.message
      : "Ocorreu um erro inesperado.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-lg w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-lg font-semibold text-slate-900">Erro inesperado no aplicativo</h1>
        <p className="mt-3 text-sm text-slate-600 break-words">{message}</p>
        <p className="mt-4 text-xs text-slate-500">
          Se o Google Tradutor estiver ativo, desative-o nesta página e tente novamente.
        </p>
        <Link
          to={ROUTES.HOME}
          className="mt-6 inline-flex items-center rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
        >
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}
